import { Menu } from './SideBar';
import GridComponent from '../grid/GridComponent.component';
import { LinkRouter } from '../link/Link';
import { Container } from '../container/Container';
import { SideBarInterface } from './SideBarInterface';
import accessToMenuOtions from './AccessToMenuOtions';

export default function SideBar() {

    return (
        <GridComponent justify="center" alignItems="center">
            {  accessToMenuOtions().map((el: SideBarInterface, index: number) => {
                return (
                    <Container margin="10px" key={index}>
                        <LinkRouter to={el.to} color="#095AA5">
                            <Menu>
                                <GridComponent justify="center" direction="column" alignItems="center">
                                    <Container margin="20px 0px 0px 0px">{el.icon}</Container>
                                    <div>{el.text}</div>
                                </GridComponent>
                            </Menu>
                        </LinkRouter>
                    </Container>
                )
            })}
        </GridComponent>
    );
}
